

const CRUD ={
        CREATE:'Add',
        LIST:'List',
        UPDATE:'Edit',
        DELETE:'Delete',
        VIEW:'View'
}

export default Object.freeze({
        ...CRUD,
        USER:{
                ...CRUD,
        },
        ROLE:{
                ...CRUD,
        },
        CARDHOLDER:{
                ...CRUD,
                BULKUPLOAD:'Bulk-Upload',
                TOPUPBULK:"Topup",
                APPROVE:"Approve",
                TOPUPCARDHOLDERWALLET:"Topup",
                BLOCKCARD:"Blocked",
                REJECT:'Reject',
                CLOSE:'Close',
                UNBLOCK:'Unblock',
                INITIALTOPUP:"InitialTopUp"
        },
        TOPUP:{
                TOPUPMASTER:'TopupMaster',
                APPROVE:'ListPendingTopUp',
                LISTPENDING:'Pending TopUp List',
                APPROVEREJECT:'Approve/Reject',
        },
        NOTIFICATION:{
                ...CRUD,
                SEND:'Send'
        },
        MANAGEACCOUNT:{
                TOPUPMASTER :'TopupMaster',
                LOADMASTER:'LoadMaster',
                LISTPENDINGTOPUP:'ListPendingTopUp'
        },
        MANAGEROLE:{
                ...CRUD
        },
        MANAGEUSER:{
                ...CRUD
        },
        CLAIMS:{
                ...CRUD,
                APPROVAL : 'Approve',
                EXPORTEXCEL:'Export'
        },
        RECURRINGTOPUP: {
                ...CRUD,
                APPROVEREJECT:'Approve/Reject',
        }

})